import React from "react";
import { Chart, Doughnut } from "react-chartjs-2";
import ChartDataLabels from "chartjs-plugin-datalabels";

let DoughnutComponent = React.memo((props) => {
  return (
    <Doughnut
      plugins={[ChartDataLabels]}
      data={{
        labels: ["A", "B", "C", "D", "E", "F"],
        datasets: [
          {
            label: "d2epc",
            data: [
              props.typeAnumber,
              props.typeBnumber,
              props.typeCnumber,
              props.typeDnumber,
              props.typeEnumber,
              props.typeFnumber,
            ],
            color: "black",
            backgroundColor: [
              "#145214",
              "#2eb82e",
              " #85e085",
              "#cccc00",
              "#ff9900",
              "#e62e00",
            ],
            hoverBackgroundColor: [
              "#145214",
              "#2eb82e",
              " #85e085",
              "#cccc00",
              "#ff9900",
              "#e62e00",
            ],
            borderColor: [
              "#4d4d4d",
              "#4d4d4d",
              "#4d4d4d",
              "#4d4d4d",
              "#4d4d4d",
              "#4d4d4d",
            ],
            hoverBorderColor: [
              "#cccccc",
              "#cccccc",
              "#cccccc",
              "#cccccc",
              "#cccccc",
              "#cccccc",
            ],
            circumference: 360,
            cutout: "45%",
            borderRadius: 8,
            borderWidth: 2,

            hoverOffset: 14,
          },
        ],
      }}
      options={{
        animation: {
          duration: 1000,
        },
        responsive: true,
        plugins: {
          datalabels: {
            formatter: (value) => {
              return (
                Math.round(
                  (100 * value) /
                    (props.typeAnumber +
                      props.typeBnumber +
                      props.typeCnumber +
                      props.typeDnumber +
                      props.typeEnumber +
                      props.typeFnumber)
                ) + "%"
              );
            },
            display: true,
            align: "center",
            anchor: "center",
            clip: false,
            color: "black",

            font: {
              weight: "bold",
              size: 18,
            },
          },
          legend: {
            labels: { color: "black" },
            position: "bottom",
          },
          title: {
            display: true,
            font: { size: "20rem" },
            text: props.doughnutTitle,
            color: "black",
          },
        },
      }}
    />
  );
});

export default DoughnutComponent;
